import React, { FC } from 'react';
import classNames from 'classnames';

import { ProgressBarState } from './types';

import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  value: number;
  max?: number;
  state?: ProgressBarState;
  sectionsNumber?: number;
};

export const ProgressBar: FC<ProgressBarProps> = ({
  value,
  max,
  state = ProgressBarState.NEUTRAL,
  sectionsNumber = 4,
}) => {
  const progressPercent = max ? value / (max / 100) : 100;
  const percentPerSection = (100 / sectionsNumber);
  const filledSectionsNumber = Math.floor(progressPercent / percentPerSection);
  const lastSectionProgressPercent = (progressPercent % percentPerSection) * sectionsNumber;

  const rootClassName = classNames(styles.root, {
    [styles.success]: state === ProgressBarState.SUCCESS,
    [styles.note]: state === ProgressBarState.NOTE,
    [styles.brand]: state === ProgressBarState.BRAND,
  });

  return (
    <ul className={rootClassName}>
      {Array.from({ length: sectionsNumber }).map((_, index) => {
        const hasProgress = filledSectionsNumber >= index;
        const isCompletelyFilled = filledSectionsNumber >= index + 1;
        const width = isCompletelyFilled ? '100%' : `${lastSectionProgressPercent}%`;

        return (
          <li key={index}
              className={styles.section}>
            {hasProgress && (
              <div className={styles.progress}
                   style={{ width }} />
            )}
          </li>
        );
      })}
    </ul>
  );
};
